import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import MainLayout from '../components/layout/MainLayout';
import { SectionHome, LAST_TAB_PREFIX } from '../components/enterprise';
import { CheckSquare, Target, PiggyBank, Truck } from 'lucide-react';

const getLastTab = (section) => {
  try {
    const raw = localStorage.getItem(`${LAST_TAB_PREFIX}${section}`);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

const VerbeterenHomePage = () => {
  const { api } = useAuth();
  const [stats, setStats] = useState({ waiting: 0, requests: 0 });
  const lastTab = getLastTab('verbeteren');

  useEffect(() => {
    const fetch = async () => {
      try {
        const [mRes, lRes] = await Promise.all([
          api.get('/ggrc/measures').catch(() => ({ data: [] })),
          api.get('/supplier-requests').catch(() => ({ data: [] })),
        ]);
        const measures = Array.isArray(mRes.data) ? mRes.data : [];
        const waiting = measures.filter(m => m.status === 'planned' || m.status === 'suggested').length;
        const requests = Array.isArray(lRes.data) ? lRes.data.length : 0;
        setStats({ waiting, requests });
      } catch {}
    };
    fetch();
  }, [api]);

  return (
    <MainLayout>
      <SectionHome
        question="Wat wil je verbeteren?"
        subtitle="Kies het resultaat dat je vandaag wilt bereiken."
        resume={lastTab ? { title: lastTab.label, href: lastTab.href } : undefined}
        recommended={{
          title: 'Start een aanbevolen maatregel',
          description: 'Voer direct een oplossing uit voor een bestaand risico. Begin met de maatregel die de meeste impact heeft.',
          href: '/verbeteren/maatregelen',
          status: stats.waiting > 0 ? `${stats.waiting} wachten op uitvoering` : null,
          duration: 'Enkele minuten per maatregel',
          icon: CheckSquare,
        }}
        alternatives={[
          {
            title: 'Kies mijn volgende verbeterdoel',
            description: 'Bekijk en activeer je verbeterplan op basis van volwassenheidsniveaus.',
            href: '/verbeteren/strategie',
            icon: Target,
          },
          {
            title: 'Bereken de financiële impact van risico\'s',
            description: 'Vul de geschatte schade en oplossingskosten aan per risico.',
            href: '/verbeteren/financieel',
            icon: PiggyBank,
          },
          {
            title: 'Zoek externe hulp of volg een aanvraag',
            description: 'Vind een leverancier voor uitvoering of advies, of volg een lopende aanvraag.',
            href: '/verbeteren/leveranciers',
            status: stats.requests > 0 ? `${stats.requests} aanvragen` : null,
            icon: Truck,
          },
        ]}
        overviewHref="/verbeteren/maatregelen"
        overviewLabel="Bekijk alle maatregelen"
        testId="verbeteren-home"
      />
    </MainLayout>
  );
};

export default VerbeterenHomePage;
